/* global Omise */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CircularProgress from '@mui/material/CircularProgress';
import BookingAppBarComponent from '../../../component/booking_appbar';
import promotion_bg from '../../../images/BG-True_44.jpg';

import {
  Container,
  Grid,
  Typography,
  Button,
  Box,
  TextField,
  Divider,
  Chip,
  useMediaQuery,
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, StaticDatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';

import { BsCheckCircleFill } from "react-icons/bs";
import AddIcon from '@mui/icons-material/Add';

import RemoveIcon from '@mui/icons-material/Remove';
import CustomStepper from '../../../component/timeline';
import { AlertError } from '../../../component/popupAlert';

import { CheckBoat } from '../../../service/booking_service';

import './style_booking.css';
import { getTimeSlotsActive, getTimeSlotSpecialDay } from '../../../service/utinity_service';
import ImageCarousel from '../../../component/banner';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next'; // เพิ่มบรรทัดนี้
import Landingpage_view from '../landingpage/landingpage_view';
import PromotionDialog from '../../../component/PromotionDialog';

const BookingView = () => {
  const { t } = useTranslation('booking');
  const { t: popup_promo } = useTranslation('popup_promo');
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:1200px)');
  const isMobile2 = useMediaQuery('(max-width:1600px)');

  const [adults, setAdults] = useState(0);
  const [children, setChildren] = useState(0);
  const [openDialog, setOpenDialog] = useState(true);
  const [countPeople, setCountPeople] = useState(0);
  const [tel, setTel] = useState();
  const [disable, setDisable] = useState(false);
  const [visible, setVisible] = useState(false);
  const [submittingBtn, setSubmittingBtn] = useState(false);
  const DefaultDate = new Date();
  DefaultDate.setDate(DefaultDate.getDate() + 1);
  const [selectedDate, setSelectedDate] = useState(DefaultDate);
  const [selectedTime, setSelectedTime] = useState(null);

  const [timeSlots, setTimeSlots] = useState([])

  const [adultPrice, setAdultPrice] = useState(0)
  const [childPrice, setChildPrice] = useState(0)
  const [totalPrice, setTotalPrice] = useState(0)

  const [first_name, setFirstname] = useState('');
  const [email, setEmail] = useState('');
  const [last_name, setLastName] = useState('');
  const [address, setAddress] = useState('');

  const [step, setStep] = useState(1);
  const [People, setPeople] = useState(0);
  const [peopleformTime, setTotalPeopleformTime] = useState(0);

  const [loading, setLoading] = useState(false);
  const [loadingTime, setLoadingTime] = useState(false);

  useEffect(() => {
    setLoading(false);
    try {
      const language = Cookies.get('language');
      i18next.changeLanguage(language);
      Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY)
      // console.log('counter', countPeople)
      // console.log('people', People)

      if (selectedDate && !selectedTime && adults === 0 && children === 0) {
        setStep(1);
        handleMaxPeople()
        setVisible(false);
      } else if (selectedDate && selectedTime) {
        if (adults === 0 && children === 0) {
          setStep(2);
          handleMaxPeople()
          setVisible(true);
          setSubmittingBtn(false);
        } else {
          setStep(3);
          handleMaxPeople()
          setVisible(true);
          setSubmittingBtn(true);
        }
      }
      let people = peopleformTime - (countPeople + adults + children)
      // console.log("setPeople = ", people)
      setPeople(people)
      init()
      setLoading(true);
    } catch (error) {
      console.log("error: ", error)
      //navigate('/404');
    }
    setTotalPrice((adults * adultPrice) + (children * childPrice))
  }, [selectedDate, selectedTime, adults, children, countPeople]);


  const init = async () => {
    await handleGetTimeSlot()
  }

  const handleGetTimeSlot = async () => {
    try {
      // First, get time slots for special days based on the selected date
      const res = await getTimeSlotSpecialDay(format(selectedDate, 'dd-MM-yyyy'));
      console.log('timeSlots Specialdays', res);

      // If there are time slots, set them; otherwise, fetch active time slots
      if (res.length > 0) {
        // กรองเฉพาะรายการที่ status เป็น 'active'
        const activeTimeSlots = res.filter((item) => item.status === 'active');

        setTimeSlots(activeTimeSlots);

        if (selectedTime) {
          const time = activeTimeSlots.find((item) => item.time === selectedTime);
          if (time) {
            setAdultPrice(time.price_adult || 0);
            setChildPrice(time.price_children || 0);
          }
        }
      } else {
        const activeTimeSlots = await getTimeSlotsActive();
        setTimeSlots(activeTimeSlots);
        if (selectedTime) {
          const time = activeTimeSlots.find((res) => res.time === selectedTime)
          // console.log(time)
          setAdultPrice(time.price_adult || 0)
          setChildPrice(time.price_children || 0)
        }
      }
    } catch (error) {
      // Handle error by setting time slots to an empty array
      setTimeSlots([]);
    }
  };

  const handleMaxPeople = async () => {
    // const res = await getTimeSpecialdaysTime(format(selectedDate, 'dd-MM-yyyy'), selectedTime)

    const countPeople = await CheckBoat(format(selectedDate, 'dd-MM-yyyy'), selectedTime);
    if (countPeople.total_people && countPeople.total_people > 0) {
      setCountPeople(countPeople.total_people);
    } else {
      setCountPeople(0);
    }
  }

  const setDefaul = async () => {
    setAdults(0);
    setChildren(0);
    setTel('');
    setFirstname('');
    setLastName('');
    setEmail('');
    setOpenDialog(false);
    setTotalPeopleformTime(0)
    setAdultPrice(0);
    setChildPrice(0);
  }

  const handleTimeSelect = (time, people) => {
    setDefaul();
    setDisable(true);
    setSelectedTime(time);
    // console.log("person", people);
    setTotalPeopleformTime(people)
    handleGetTimeSlot()

  };

  const handleBooking = () => {
    Cookies.set('adults', adults, { expires: 1 })
    Cookies.set('children', children, { expires: 1 })
    Cookies.set('time', selectedTime, { expires: 1 })
    Cookies.set('date', selectedDate, { expires: 1 })
    Cookies.set('total_prices', totalPrice, { expires: 1 })
    Cookies.set('price_adult', adultPrice, { expires: 1 })
    Cookies.set('price_children', childPrice, { expires: 1 })
    handleSubmitted()
    //setOpenDialog(true);
  };

  const handlePickTime = (newValue) => {
    setDefaul()
    setDisable(true);
    setSelectedDate(newValue);
    setSelectedTime()
    handleMaxPeople()
  };

  const handleAdultsAdd = () => {
    //setAdults(adults + 1);
    if (peopleformTime - countPeople < 0) {
      setAdults(adults)
      return
    }

    if ((adults + children) === (peopleformTime - countPeople)) {
      setAdults(adults)
    } else {
      setAdults(adults + 1);
    }
  };

  const handleTimeSlotIsAble = (time) => {
    // console.log('Selected Date:', selectedDate);
    // console.log('Time:', time);

    // Split the time string into start and end times
    const [startTime, endTime] = time.split(' - ');

    // Extract hours and minutes from the start time
    const [hours, minutes] = startTime.split(":").map(Number);

    // Create a new date object for the selected date and start time
    const newDateTime = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      hours,
      minutes,
      0
    );

    // Get the current date and time
    const nowTime = new Date();

    // console.log("New Date:", newDateTime);

    // Check if the new date is at least 1 day after the current date
    return newDateTime.getTime() >= new Date(nowTime.getTime() + 24 * 60 * 60 * 1000).getTime();
  };

  const handleAdultsMinus = () => {
    setAdults(Math.max(0, adults - 1));
  };

  const handleChildrenAdd = () => {
    // setChildren(children + 1);
    if (peopleformTime - countPeople < 0) {
      setChildren(children)
      return
    }

    if ((adults + children) === (peopleformTime - countPeople)) {
      setChildren(children)
    } else {
      setChildren(children + 1)
    }
  };

  const handleChildrenMinus = () => {
    setChildren(Math.max(0, children - 1));
  };

  const handleSubmitted = async () => {
    setOpenDialog(false);
    if (children >= 0 && adults <= 0) {
      AlertError(t('error_text'), t('error_child'))
      return;
    }

    navigate('/checkout')
    handleMaxPeople();
  };


  const handleCustomerText = () => {

    if (step === 1) {
      return (
        <Box className="text-center" sx={{ padding: 1, display: 'flex' }}>
          <Box>
            <Typography variant="h7" gutterBottom className="mb-2" sx={{ color: '#999999', fontWeight: 'bold' }}>
              {t('title_selectslot')}
            </Typography>
          </Box>
        </Box>
      )
    }

    if ((peopleformTime - countPeople) === 0) {
      // console.log("((peopleformTime - countPeople) === 0)")
      // console.log("people", peopleformTime)
      // console.log("countPeople", countPeople)
      return (
        <Box className="text-center" sx={{ padding: 1, display: 'flex' }}>
          <Box>
            <Typography variant="h7" gutterBottom className="mb-2" sx={{ color: 'red', fontWeight: 'bold' }}>
              {t('title_full_booking')}
            </Typography>
            <Typography gutterBottom className="mb-2" sx={{ color: '#b0b0b0', fontWeight: 'bold', fontSize: '14px' }}>
              {t('title_avalible_des')} {peopleformTime} {t('unit_booking')} {t('title_avalible_booking_des')}
            </Typography>
          </Box>
        </Box>
      )
    } else {
      if (People > 0) {
        return (
          <Box className="text-center" sx={{ padding: 1, display: 'flex' }}>

            <Box m={1} sx={{ margin: '8px 8px 8px 0px' }}>
              <BsCheckCircleFill size={34} color='green' />
            </Box>
            <Box>
              <Box>
                <Typography variant="h7" gutterBottom className="mb-2" sx={{ color: 'green', fontWeight: 'bold' }}>
                  {t('title_available_booking')} {People} {t('unit_booking')}
                </Typography>

                <Typography gutterBottom className="mb-2" sx={{ color: '#b0b0b0', fontWeight: 'bold', fontSize: '14px' }}>
                  {t('title_avalible_des')} {peopleformTime} {t('unit_booking')} {t('title_avalible_booking_des')}
                </Typography>
              </Box>
            </Box>
          </Box>
        )
      } else {
        console.log('People < 0')
        return (
          <Box className="text-center" sx={{ padding: 1, display: 'flex' }}>
            <Box>
              <Typography variant="h7" gutterBottom className="mb-2" sx={{ color: 'red', fontWeight: 'bold' }}>
                {t('title_full_booking_2')}
              </Typography>

              <Typography gutterBottom className="mb-2" sx={{ color: '#b0b0b0', fontWeight: 'bold', fontSize: '14px' }}>
                {t('title_avalible_des')} {peopleformTime} {t('unit_booking')} {t('title_avalible_booking_des')}
              </Typography>
            </Box>
          </Box>
        )
      }
    }
  }

  return (
    <Box sx={{marginBottom : 0}}>
      <BookingAppBarComponent />
      <Box sx={{ marginTop: '90px', marginBottom: 0 }}>
        <ImageCarousel />
      </Box>
      <Box
        sx={{
          // minHeight: '100vh',
          width: '100%',
          // backgroundImage: `url(${bg_pic})`,
          // backgroundColor:'#FEFEFE',
          backgroundSize: '100% auto',
          backgroundPosition: 'top', // ชิดขอบบน
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start', // ชิดขอบบนของเนื้อหาด้านใน
          width: '100%', // กว้างเต็มหน้าจอ
          // height: '100vh', // สูงเต็มหน้าจอ
          height: isMobile ? '1150px !important' : '800px !important',
          overflow: 'hidden',
          padding: isMobile ? 0 : theme.spacing(2),
        }}
      >
        <div
          style={{
            position: 'absolute',
            textAlign: 'center',
            width: '76%',
            border: '0px solid #f00',
            marginTop: isMobile ? '10px' : '20px',
            color: '#54cfe4',
            textShadow: '1px 1px 15px #FFF',
          }}
        >
          <h1 style={{ fontSize: isMobile2 ? isMobile ? 20 : 32 : 46, letterSpacing: isMobile ? 'auto' : '5px', marginBottom: '10px', textTransform: 'uppercase', fontFamily: "'STIX Two Text', serif", }}>
            {t('title1')}
          </h1>
          <h2 className="stix-font" style={{ fontSize: isMobile ? 16 : 20, marginBottom: '4px', letterSpacing: isMobile2 ? isMobile ? 'auto' : '5px' : '5px', textTransform: 'uppercase', fontFamily: "'prompt', serif", }}>
            {t('title2')}
          </h2>
          <h2 style={{ fontSize: isMobile ? 14 : 16, marginBottom: '8px', letterSpacing: isMobile ? 'auto' : '4px', textTransform: 'uppercase', fontFamily: "'prompt', serif", }}>
            {t('title3')}
          </h2>
          <p style={{ fontSize: isMobile ? 14 : 16, marginTop: '10px', color: '#000000', textAlign: 'center', maxWidth: isMobile ? 'auto' : '850px', marginLeft: 'auto', marginRight: 'auto', fontFamily: "'prompt', serif" }}>
            {t('description')}
          </p>
        </div>

        <Box sx={{
          position: 'relative',
          borderRadius: 3,
          width: isMobile ? '100%' : '80%',
          minWidth: isMobile ? '240px' : '1200px',
          padding: '0px',
          marginTop: isMobile2 ? isMobile ? '230px' : '260px' : '250px',
          padding: isMobile ? 0 : theme.spacing(1),
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: !loading ? 'transparent' : 'white',
            opacity: 0.85,
            borderRadius: 'inherit',
          },
        }}>

          {!loading ?
            <Box
              sx={{
                position: 'relative',
                zIndex: 1,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: isMobile ? '1000px' : 'auto',

              }}
            >
              <CircularProgress />
            </Box>
            :
            <Box>
              {!isMobile && (
                <Box sx={{ position: 'relative', zIndex: 1, width: '100%', paddingTop: isMobile ? '1000px' : 'auto' }}>
                  <CustomStepper currentStep={step - 1} />
                </Box>)}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Container maxWidth="xl"
                  sx={{
                    mt: 1,
                    padding: '0px !important',
                    margin: '0px !important',
                    backgroundClip: 'white',
                    height: '100vh',
                    opacity: '1',
                    position: 'relative',
                    zIndex: 1,
                  }}>
                  {/* <Paper elevation={3} sx={{ mt: 3, p: 1, width: '100%', margin: 0, padding: 0, border:'1px solid #00f' }} > */}
                  <Grid container spacing={2} columns={12} sx={{ width: '100%', margin: 0, padding: '15px', border: '0px solid #0f0' }}>
                    <Grid xs={12} sm={12} md={12} lg={4} xl={4} sx={{ minWidth: '360px', border: '0px solid #efefef', padding: '5px', margin: "0px", borderRadius: '10px' }}>
                      <Grid className="rentDatePicker" sx={{ margin: '0px', border: '1px solid #efefef', height: isMobile ? 'auto' : '380px', bgcolor: '#fff', borderRadius: '10px', padding: '20px' }}>
                        {isMobile ? (
                          <MobileDatePicker
                            label="กรุณาระบุวันเดินทาง"
                            value={selectedDate}
                            minDate={DefaultDate}
                            onChange={(newValue) => handlePickTime(newValue)}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                            sx={{ width: '100%', border: '0px solid #f00' }}
                          />
                        ) : (
                          <StaticDatePicker
                            displayStaticWrapperAs="desktop"
                            value={selectedDate}
                            minDate={DefaultDate}
                            onChange={(newValue) => handlePickTime(newValue)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Grid xs={12} sm={12} md={12} lg={4} xl={4} sx={{ minWidth: '370px', border: '0px solid #efefef', padding: '5px', margin: "0px", borderRadius: '10px' }}>
                      <Grid sx={{ margin: '0px', border: '1px solid #efefef', height: isMobile ? 'auto' : '380px', bgcolor: '#fff', borderRadius: '10px', padding: '20px', overflow: 'scroll', overflowX: 'hidden' }}>
                        {/* {
                          !loadingTime ? <Box>
                            <Grid container spacing={1}>
                              {timeSlots.map((time) => (
                                <Grid item xs={6} key={time}>
                                  <Button
                                    fullWidth
                                    variant={selectedTime === time.time ? "contained" : "outlined"}
                                    onClick={() => handleTimeSelect(time.time, time.total_people)}
                                    sx={{ borderRadius: 4 }}
                                    disabled={!handleTimeSlotIsAble(time.time)}
                                  >
                                    {time.time}
                                  </Button>
                                </Grid>
                              ))}
                            </Grid>
                          </Box> :
                            <Box
                              sx={{
                                position: 'relative',
                                zIndex: 1,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingTop: isMobile ? '1000px' : 'auto',
                              }}
                            >
                              <CircularProgress />
                            </Box>
                        } */}
                        {
                          timeSlots.length === 0 ?
                            <Box>
                              <Typography style={{ textAlign: 'center', marginTop: '10px', fontSize: '18px' }}>{t('title_notimeslot')}</Typography>
                            </Box> :
                            <Box>
                              <Grid container spacing={1}>
                                {timeSlots.map((time) => (
                                  <Grid item xs={6} key={time}>
                                    <Button
                                      fullWidth
                                      variant={selectedTime === time.time ? "contained" : "outlined"}
                                      onClick={() => handleTimeSelect(time.time, time.total_people)}
                                      sx={{ borderRadius: 4 }}
                                      disabled={!handleTimeSlotIsAble(time.time)}
                                    >
                                      {time.time}
                                    </Button>
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                        }
                      </Grid>
                    </Grid>
                    <Grid xs={12} sm={12} md={12} lg={4} xl={4} sx={{ minWidth: '360px', border: '0px solid #efefef', padding: '5px', margin: "0px", borderRadius: '10px' }}>
                      <Grid sx={{ margin: '0px', border: '1px solid #efefef', height: isMobile ? 'auto' : '380px', backgroundColor: '#fff', borderRadius: '10px', padding: '20px' }}>
                        {handleCustomerText()}
                        <Box sx={{ padding: 1 }} >
                          <Grid container spacing={2} columns={16} sx={{ margin: '8px 0px', width: '345px', border: '0px solid #f00', width: '100%' }}>
                            <Grid sx={{ border: '0px solid #0f0', padding: '0px', width: 'auto', flexGrow: 1 }}>
                              <Box>
                                <Typography sx={{ paddingTop: '3px' }}>
                                  <h5 style={{ margin: '0px', color: '#515151' }}>
                                    <span style={{ fontSize: '20px' }}>{t('adults')}</span> <small>{t('a_age')}
                                      <br /><span style={{ color: '#00a9dd', fontWeight: '500', fontSize: '14px' }}>THB {adultPrice.toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                      </span></small></h5>
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid lg={8} sx={{ border: '2px solid #ddd', borderRadius: '10px' }}>
                              <Box>
                                <Box display="flex" alignItems="center" sx={{ border: '0px solid #f00' }}>
                                  <Button onClick={(e) => handleAdultsMinus(e)} sx={{ width: '25px', height: '50px', padding: '5px' }} disabled={!disable}>
                                    <RemoveIcon />
                                  </Button>
                                  <Typography sx={{ mx: 2, width: 'auto', flexGrow: 1, textAlign: 'center' }}>{adults}</Typography>
                                  <Button onClick={(e) => handleAdultsAdd(e)} disabled={!disable} sx={{ width: '25px', height: '50px' }}>
                                    <AddIcon />
                                  </Button>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid container spacing={2} columns={16} sx={{ margin: '10px 0px', width: '345px', border: '0px solid #f00', width: '100%' }}>
                            <Grid sx={{ border: '0px solid #0f0', marginTop: '0px', width: 'auto', flexGrow: 1 }}>
                              <Box>
                                <Typography sx={{ paddingTop: '3px' }}>
                                  <h5 style={{ margin: '0px', color: '#515151', paddingTop: '8px' }}>
                                    <span style={{ fontSize: '20px' }}>{t('child')}</span> <small>{t('c_age')}
                                      <br /><span style={{ color: '#00a9dd', fontWeight: '500', fontSize: '14px' }}>THB {childPrice.toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                      </span></small></h5>
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid lg={8} sx={{ border: '2px solid #ddd', borderRadius: '10px', marginTop: '10px' }}>
                              <Box display="flex" alignItems="center">
                                <Button onClick={(e) => handleChildrenMinus(e)} disabled={!disable} sx={{ width: '25px', height: '50px' }}>
                                  <RemoveIcon />
                                </Button>
                                <Typography sx={{ mx: 2, width: 'auto', flexGrow: 1, textAlign: 'center' }}>{children}</Typography>
                                <Button onClick={(e) => handleChildrenAdd(e)} disabled={!disable} sx={{ width: '25px', height: '50px' }}>
                                  <AddIcon />
                                </Button>
                              </Box>
                            </Grid>

                            <Grid lg={16} sx={{ border: '0px solid #ddd', margin: '20px 0px 0px 0px' }}>
                              <Divider>
                                {/* <Chip label="Chip" size="small" /> */}
                              </Divider>
                            </Grid>

                          </Grid>

                          <Grid container spacing={2} columns={16} sx={{ margin: '10px 0px', border: '0px solid #f00', width: '100%' }}>
                            <Grid sx={{ border: '0px solid #0f0', marginTop: '0px', width: 'auto', flexGrow: 1 }}>
                              <Box>
                                <Typography sx={{ paddingTop: '0px' }}>
                                  <h2 style={{ margin: '0px', color: '#515151', paddingTop: '0px' }}>
                                    <span style={{ color: '#00a9dd' }}>{t('total')}</span>
                                    <div style={{ color: '#515151', paddingTop: '-10px', fontSize: '12px', fontWeight: '500' }}>
                                      ({t('vat')})
                                    </div>
                                  </h2>
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid lg={8} sx={{ border: '0px solid #ddd', textAlign: 'right', marginTop: '0px' }}>
                              <h2 style={{ margin: '0px', color: '#00a9dd' }}>
                                {totalPrice.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })} {t('unit')}
                              </h2>
                            </Grid>
                          </Grid>
                          {/* <Typography variant="h6" align="right">ยอดรวม: {totalPrice.toFixed(2)} บาท</Typography> */}
                          <Button
                            className='BookNow_Btn_Booking_page'
                            variant="contained"
                            color="info"
                            size="large"
                            onClick={handleBooking}
                            sx={{ borderRadius: '50px', margin: '10px 0px 10px 0px', width: '100%', backgroundColor: '#55D0E4' }}
                            disabled={!submittingBtn}
                          >
                            <h4 style={{ margin: '0px' }}>Book Now</h4>
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Box
                    sx={{
                      position: 'absolute',
                      textAlign: 'center',
                      width: '100%',
                      border: '0px solid #f00',
                      marginTop: '10px',
                      marginBottom: '10px',
                      color: '#000'
                    }}>
                    <Divider sx={{ borderColor: '#FFF3CD' }}>
                      {!isMobile && (<Chip label={t('warnig')}
                        size="small"
                        sx={{
                          backgroundColor: '#FFF3CD',
                          borderColor: '#FFF3CD'
                        }} />)}
                    </Divider>

                  </Box>
                  {/* ถ้ามีเปิดPopup ตรงนี้ถ้ามี Promotion */}
                  <PromotionDialog  
                    open={openDialog}
                    onClose={() => setOpenDialog(false)} 
                  />
                </Container>
              </LocalizationProvider>
            </Box>
          }
        </Box>
      </Box>
      <Landingpage_view />
    </Box>

  );
};

export default BookingView;